exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na{\n  color:blue;\n}\n.notification-status {\n  border: 0;\n  background: transparent;\n  padding: 4px;\n  font-size: 18px;\n  line-height: 1;\n}\n.notification-status.unread {\n  color: #dc3545;\n  cursor: pointer;\n}\n.notification-status.read {\n  color: #28a745;\n}\n", ""]);

// exports
